// src/pages/Company/EditProfile/EditProfile.tsx
import React from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Input } from '../../../../UI/Input/Input';
import { EditWrapper } from '../../../../components/EditWrapper/EditWrapper';
import { axiosInstance } from '../../../../helpers/axios';
import { useAppDispatch } from '../../../../hooks/reduxHooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/reduxHooks/useAppSelector';
import { PATH_DASHBOARD } from '../../../../routes/RouterConfig';
import { getCompanyRetrieve } from '../../../../store/reducers/CompanySlice';
import styles from './EditProfile.module.scss';

import { getOrganizationEditSchema } from '../../../../validations/organizationValidation';

interface EditProfileFormValues {
    full_title: string;
    short_title: string;
    phone: string;
}

export const EditProfile: React.FC = () => {
    const id = useAppSelector((state) => state.authReducer.id);
    const company = useAppSelector((state) => state.companyReducer.company);

    const dispatch = useAppDispatch();

    const initialValues: EditProfileFormValues = {
        full_title: company?.full_title ?? '',
        short_title: company?.short_title ?? '',
        phone: company?.phone ?? '',
    };

    const formik = useFormik<EditProfileFormValues>({
        validateOnMount: true,
        enableReinitialize: true,
        initialValues,
        validationSchema: getOrganizationEditSchema(),
        onSubmit: async (values, { setSubmitting }) => {
            if (!id) {
                toast.error('Не удалось определить пользователя');
                return;
            }

            const url = `/v1/company/${id}/`;
            try {
                await axiosInstance.put(url, values);
                toast.success('Данные профиля успешно изменены');
                dispatch(getCompanyRetrieve(Number(id)));
            } catch (error) {
                toast.error('Произошла ошибка. Попробуйте позже');
            } finally {
                setSubmitting(false);
            }
        },
    });

    return (
        <div className={styles.companyEditProfile}>
            <form onSubmit={formik.handleSubmit} className={styles.EditProfile}>
                <EditWrapper
                    saveLink={PATH_DASHBOARD.company.root}
                    rejectLink={PATH_DASHBOARD.company.root}
                    title={'О компании'}
                    isValid={formik.isValid}
                    saveOnclick={formik.handleSubmit}
                >
                    <div className={styles.EditAbout__wrapper}>
                        <Input
                            headerClassName={styles.input__header}
                            fieldClassName={styles.input__field}
                            inputHeader={'Полное название'}
                            placeholder={'Полное название'}
                            name="full_title"
                            value={formik.values.full_title}
                            errorMessage={formik.touched.full_title ? formik.errors.full_title : ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isValid={Boolean(formik.values.full_title) && !formik.errors.full_title}
                        />

                        <Input
                            headerClassName={styles.input__header}
                            fieldClassName={styles.input__field}
                            inputHeader={'Название'}
                            placeholder={'Название'}
                            name="short_title"
                            value={formik.values.short_title}
                            errorMessage={formik.touched.short_title ? formik.errors.short_title : ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isValid={Boolean(formik.values.short_title) && !formik.errors.short_title}
                        />

                        <Input
                            headerClassName={styles.input__header}
                            fieldClassName={styles.input__field}
                            inputHeader={'Телефон'}
                            placeholder={'+71234567890'}
                            name={'phone'}
                            value={formik.values.phone}
                            errorMessage={formik.touched.phone ? formik.errors.phone : ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isValid={Boolean(formik.values.phone) && !formik.errors.phone}
                        />
                    </div>
                </EditWrapper>
            </form>
        </div>
    );
};

export default EditProfile;